import { render, staticRenderFns } from "./MiddlewareSimpleTable.vue?vue&type=template&id=a998b0e6"
import script from "./MiddlewareSimpleTable.vue?vue&type=script&lang=js"
export * from "./MiddlewareSimpleTable.vue?vue&type=script&lang=js"
import style0 from "./MiddlewareSimpleTable.vue?vue&type=style&index=0&id=a998b0e6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports